export default __webpack_public_path__ + "static/media/label.2e90c81b.svg";